import api from "./client";
import type { Plan } from "@/types/api";

export const getPlans = (): Promise<Plan[]> =>
  api.get("/v1/plans").then((res) => res.data.data);
